import React, { useEffect, useState } from 'react';
import '../../styles/examination/main.css';
import { getAllExamSchedule, getAllRevisedExamSchedule } from '../../Services/AllAPIs';
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [examSecheduleData, setExamSecheduleData] = useState([]);
    const [examRevisedSecheduleData, setRevisedExamSecheduleData] = useState([]);
    const [error, setError] = useState(null);

    // Fetch exam schedule data
    const getExamSechedule = () => {
        getAllExamSchedule()
            .then((res) => {
                // console.log('ExamSchedule--->', res.data.news);
                const examScheduleData = Object.values(res.data.news || {});
                setExamSecheduleData(examScheduleData);
                setLoader(false);
            })
            .catch((error) => {
                setError("An error occurred while fetching exam schedule data.");
                setLoader(false);
            });
    };

    // Fetch revised exam schedule data
    const getRevisedExamSechedule = () => {
        getAllRevisedExamSchedule()
            .then((res) => {
                // console.log('RevisedExamSchedule--->', res.data.news);
                const RevisedexamScheduleData = Object.values(res.data.news || {});
                setRevisedExamSecheduleData(RevisedexamScheduleData);
                setLoader(false);
            })
            .catch((error) => {
                setError("An error occurred while fetching revised exam schedule data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getExamSechedule();
        getRevisedExamSechedule();
    }, []);


    // Function to format date as DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
        <div id='examinationMain'>
            <div className="examination-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row d-flex justify-content-between align-items-center">
                        {loader && <LoadingSpinner />}
                        {error && <div className="error">{error}</div>}

                        {/* Exam Schedule Table */}
                        <div className="col-md-6 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Exam Schedule</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Posted Date</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {examSecheduleData.length > 0 ? (
                                                examSecheduleData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.title}</td>
                                                        <td>{formatDate(item.created_at)}</td>
                                                        <td>
                                                            <a
                                                                href={item.url}
                                                                className="btn btn-primary btn-download"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Revised Exam Schedule Table */}
                        <div className="col-md-6">
                            <div className="admin-table">
                                <h2 className="my-heading">Revised Exam Schedule</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Posted Date</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {examRevisedSecheduleData.length > 0 ? (
                                                examRevisedSecheduleData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.title}</td>
                                                        <td>{formatDate(item.created_at)}</td>
                                                        <td>
                                                            <a
                                                                href={item.url}
                                                                className="btn btn-primary btn-download"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;
